module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_316295.5c9e4895.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetAlTFF/FormatoSimplificado_316295.pdf
// module id = 817
// module chunks = 0